import {
  Box,
  Button,
  Drawer,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  IconButton,
} from "@mui/material";
import { useEffect, useState } from "react";

export default function DrawerComplete(props) {
  const { open, handleDrawerClose, text, subText, btmText, callback } = props;
  const [value, setValue] = useState(0);

  // useEffect(() => {
  //   if (open) {
  //     setValue(3);
  //   }
  // }, [open]);

  // useEffect(() => {
  //   if (open) {
  //     const timer = setTimeout(() => {
  //       if (value == 1) {
  //         handleDrawerClose();
  //         callback();
  //       }
  //       setValue(value - 1);
  //     }, 1000);

  //     return () => clearTimeout(timer);
  //   }
  // }, [value]);

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={handleDrawerClose}
      className="drawer-common-bottom size-small"
    >
      <div className="drawer-body pw-flex">
        <div className="box-type-1 align-c">
          <div className="illust">
            <img
              src={`${process.env.PUBLIC_URL}/images/img/illust-check.svg`}
            />
          </div>
          <p className="text">
            <strong>{text}</strong>
          </p>
          <Box component="span" className="count" mt={3}>
            <div
              dangerouslySetInnerHTML={{
                __html: subText,
              }}
            />
            <div className="btm">{btmText}</div>
          </Box>
        </div>
      </div>
      <div className="drawer-foot">
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            handleDrawerClose();
            callback();
          }}
          autoFocus
        >
          확인
        </Button>
      </div>
    </Drawer>
  );
}
